/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type AdSeatMapSupportVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  vehicleStatusTelemetry: {
    __typename?: 'VehicleStatusVehicleTelemetry'
    capabilities: {
      __typename?: 'VehicleStatusVehicleCapabilities'
      seatStates: boolean
      doorState: boolean
    }
  } | null
}

export const AdSeatMapSupportVehicleFragmentDoc = gql`
    fragment AdSeatMapSupportVehicle on Vehicle {
  id
  vehicleStatusTelemetry {
    capabilities {
      seatStates
      doorState
    }
  }
}
    `
